module.exports = __webpack_public_path__ + "static/assets/4949f3ef5f0974ad37f78ca6114f93f3.png";